export default {
    ProjectTab: "ProjectTab",
    RegularTab: "RegularTab",
    BudgetTab: "BudgetTab",
    FeesTab: "FeesTab",
    RevenueOtherTab: "RevenueOtherTab",
    ExpenseOtherTab: 'ExpenseOtherTab',
    BusinessTab: "BusinessTab",
    InvestTab: "InvestTab",
    CriteriaTab: "CriteriaTab"
}